import _get from 'lodash/get'
import React, { lazy, Suspense, useEffect, useState } from 'react'
import { HEADER_FOOTER_DATA } from '../../utils/prop-type-shape'
import ShimmerLoader from '../loaders/shimmerLoader'

const mppFooter = () =>
  import('../layout/mpp/mppFooter' /* webpackPrefetch: true */)

const MppFooterComponent = lazy(mppFooter)

const Footer = ({ isLoggedIn, reqContextData, serverData }) => {
  const [isLoaded, setIsLoaded] = useState(false)

  useEffect(() => {
    ;(async () => {
      if (!isLoggedIn) {
        await mppFooter()
        setIsLoaded(true)
      }
    })()
  }, [isLoggedIn, setIsLoaded])

  if (!isLoggedIn) {
    if (isLoaded) {
      const footerData = _get(serverData, 'navigation.mpp.footer')
      return (
        // // Render Logged Out MPP [Marketing-Components] Footer
        <Suspense fallback={<ShimmerLoader />}>
          <MppFooterComponent
            data={footerData}
            reqContextData={reqContextData}
          />
        </Suspense>
      )
    }
    return <ShimmerLoader />
  }
  return <></>
}

Footer.propTypes = HEADER_FOOTER_DATA

export default Footer
